import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CookieConsentService } from '../../../core/services/cookie-consent.service';
import { CookieConsent } from '../../../core/models/cookie-consent.model';

@Component({
  selector: 'app-cookie-consent-dialog',
  templateUrl: './cookie-consent-dialog.component.html',
  styleUrls: ['./cookie-consent-dialog.component.scss']
})
export class CookieConsentDialogComponent implements OnInit, OnDestroy {
  get consent$() {
    return this.cookieConsentService.consent$;
  }

  get decided$() {
    return this.cookieConsentService.decided$;
  }

  showCustomize = false;
  preferences: Pick<CookieConsent, 'ads' | 'analytics'> = {
    ads: false,
    analytics: false
  };
  hideForRoute = false;

  private subscription = new Subscription();

  constructor(private cookieConsentService: CookieConsentService, private router: Router) {}

  ngOnInit(): void {
    this.evaluateRoute(this.router.url);

    this.subscription.add(
      this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
        const navEnd = event as NavigationEnd;
        this.evaluateRoute(navEnd.urlAfterRedirects || navEnd.url);
      })
    );

    this.subscription.add(
      this.consent$.subscribe(consent => {
        this.preferences = {
          ads: consent.ads,
          analytics: consent.analytics
        };
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  acceptAll(): void {
    this.cookieConsentService.acceptAll();
    this.showCustomize = false;
  }

  rejectNonEssential(): void {
    this.cookieConsentService.rejectNonEssential();
    this.showCustomize = false;
  }

  toggleCustomize(): void {
    this.showCustomize = !this.showCustomize;
    if (this.showCustomize && !this.cookieConsentService.hasDecided()) {
      this.preferences = { ads: true, analytics: true };
    }
  }

  savePreferences(): void {
    this.cookieConsentService.setPartialConsent({
      ads: this.preferences.ads,
      analytics: this.preferences.analytics
    });
    this.showCustomize = false;
  }

  goToSettings(): void {
    this.router.navigate(['/settings/cookies']);
  }

  private evaluateRoute(url: string): void {
    const blockedPrefixes = ['/landing', '/auth/login', '/auth/register', '/privacy', '/terms', '/settings/cookies'];
    this.hideForRoute = blockedPrefixes.some(prefix => url.startsWith(prefix));
  }
}
